/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

/**
 * Created by XPL on 2018/3/20.
 */
import jsonp from 'assets/js/jsonp';
import { commonParams, options, removePending, REQUEST_PREFIX } from './config';
import axios from 'api/axios';
import Qs from 'qs'

const debug = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'production_testing';

export let getCodeUrl = debug ? 'https://server.dev.eeidm.com/api/AccountUI/GetCheckCodeIMG' : REQUEST_PREFIX + '/AccountUI/GetCheckCodeIMG';

export function LoginCheckAPI (params, author) {
  var url = debug ? '/api/AccountUI/LoginCheckAPI' : `${REQUEST_PREFIX}/AccountUI/LoginCheckAPI`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: 'post',
    data: data,
    transformRequest: [function (data) {
      // let ret = ''
      // for (let it in data) {
      //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      // }
      // return ret
      return Qs.stringify(data);
    }],
    headers: {
      'Authorization': author
    }
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data));
  }).catch((err) => {
    return Promise.reject(err);
  });
}
// V2版登录接口
export function LoginChecker(params, author) {
  var url = debug ? '/api/AccountUI/LoginChecker' : `${REQUEST_PREFIX}/AccountUI/LoginChecker`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: 'post',
    data: data,
    transformRequest: [function (data) {
      // let ret = ''
      // for (let it in data) {
      //   ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      // }
      // return ret
      return Qs.stringify(data);
    }],
    headers: {
      'Authorization': author
    }
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n")));
  }).catch((err) => {
    return Promise.reject(err);
  });
}

export function SendSMS(params, author) {
  var url = debug ? '/api/AccountUI/SendSMS' : `${REQUEST_PREFIX}/AccountUI/SendSMS`;
  const data = Object.assign({}, {}, params);
  return axios({
    url: url,
    method: 'get',
    params: data
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data.replace(/[\r]/g, "\\r").replace(/[\n]/g, "\\n")));
  }).catch((err) => {
    return Promise.reject(err);
  });
}


export function loginOut(obj) {
  var url = debug ? '/api/AccountUI/LoginoutAPI' : `${REQUEST_PREFIX}/AccountUI/LoginoutAPI`;
  const data = Object.assign({}, commonParams, obj);
  return axios({
    url: url,
    method: 'post',
    data: data,
    transformRequest: [function (data) {
      return Qs.stringify(data);
    }],
    other: obj.other
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data));
  }).catch(err => {
    return Promise.reject(err);
  });
}




// WEBPACK FOOTER //
// ./src/api/login.js